type ZiggyGlobal = { defaults?: Record<string, unknown> }

type CurrentSiteProps = {
    user?: {
        current_site?: {
            hashid?: string | null
        } | null
    } | null
}

type PageWithProps = { props?: Record<string, unknown> }

/**
 * Keeps Ziggy's `website` route default in sync with the current workspace.
 *
 * The `@routes` Blade directive only injects `window.Ziggy` (including the
 * server-set `website` default) on a full page load. Inertia SPA visits never
 * re-run it, so a session that entered on a page without the default (e.g.
 * `/login` before a client-side visit to the dashboard) keeps a stale/empty
 * default forever — and every `route('inbox')`-style call in the persistent
 * chrome (MainMenu, Sidebar, BannerMessages) throws
 * "'website' parameter is required". Re-syncing the default from the shared
 * `user.current_site.hashid` prop on each visit fixes all of those at once.
 */
export function syncZiggyWebsiteDefault(
    page: PageWithProps | undefined,
    ziggy: ZiggyGlobal | undefined = (
        window as unknown as { Ziggy?: ZiggyGlobal }
    ).Ziggy
): void {
    const props = page?.props as CurrentSiteProps | undefined
    const hashid = props?.user?.current_site?.hashid

    if (!hashid || !ziggy) {
        return
    }

    ziggy.defaults = { ...ziggy.defaults, website: hashid }
}
